import React, { useState, useRef, useEffect } from "react";
import {
    MapContainer,
    TileLayer,
    Marker,
    Popup,
    FeatureGroup,
    LayersControl
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import {
    FaChevronDown,
    FaChevronUp,
    FaMoneyBillAlt,
    FaBuilding,
    FaExclamationTriangle,
} from "react-icons/fa";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { Expand } from "../../../../Components/IconComponents";
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";
import { GeoJSON, useMapEvents, useMap } from "react-leaflet";
import { getAllDistricts, gisCoordinatesData, gisBlockCoordinatesData, gisStateCoordinates, gisPanchayatCoordinatesData, gisVillageCoordinatesData } from "../../../../Services/EndPoints";
import { toast } from "react-toastify";
import { getData } from "../../../../Services/Services";
import { text } from "@fortawesome/fontawesome-svg-core";
import Loader from "react-spinner-loader";
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';


// Custom Icons using SVG strings
const createCustomIcon = (svg, color) => {
    return L.divIcon({
        className: "custom-icon",
        html: `<div style="color: ${color}; font-size: 24px;">${svg}</div>`,
        iconSize: [24, 24],
        iconAnchor: [12, 12],
        popupAnchor: [0, -12],
    });
};
const atmIconSvg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="none">
  <rect x="32" y="64" width="384" height="384" rx="24" fill="#333" stroke="#333" stroke-width="16"/>
  <rect x="96" y="112" width="256" height="96" rx="8" fill="#fff" stroke="#333" stroke-width="8"/>
  <rect x="96" y="232" width="256" height="32" rx="4" fill="#fff" stroke="#333" stroke-width="8"/>
  <circle cx="144" cy="296" r="12" fill="#fff"/>
  <circle cx="176" cy="296" r="12" fill="#fff"/>
  <circle cx="208" cy="296" r="12" fill="#fff"/>
  <circle cx="144" cy="328" r="12" fill="#fff"/>
  <circle cx="176" cy="328" r="12" fill="#fff"/>
  <circle cx="208" cy="328" r="12" fill="#fff"/>
</svg>`;


const branchIconSvg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" fill="#B22222">
  <path d="M0 464V256H64V464H160V352H288V464H384V320H512V464H640V224L320 0 0 224V464z"/>
</svg>`;
const redDotIcon = new L.Icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/684/684908.png",
  iconSize: [30, 30],
  iconAnchor: [15, 30],
  popupAnchor: [0, -28],
});

const incidentIconSvg =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>';

// Create icon instances
const atmIcon = createCustomIcon(atmIconSvg, "#0066cc");
const branchIcon = createCustomIcon(branchIconSvg, "#006600");
const incidentIcon = createCustomIcon(incidentIconSvg, "#cc0000");

// Color-coded incident icons based on severity
const getIncidentIcon = (severity) => {
    const colors = {
        Low: "#ffcc00", // Yellow
        Medium: "#ff9900", // Orange
        High: "#cc0000", // Red
        Critical: "#990000", // Dark Red
    };

    return createCustomIcon(incidentIconSvg, colors[severity] || "#cc0000");
};
const LocationMarker = ({ onLocationSelect }) => {
    useMapEvents({
        click(e) {
            console.log('Map clicked at:', e.latlng);
            onLocationSelect({
                latitude: e.latlng.lat,
                longitude: e.latlng.lng
            });
        }
    });
    return null;
};
const EventMap = ({ selectedDistrictIds, selectedDistrictId, selectedBlockIds, isLoading, selectedRegions, selectedPanchayatIds, selectedVillageIds, selectedFacilities, onLocationSelect,clickedPoint,setClickedPoint }) => {
    const handle = useFullScreenHandle();
    const [showATMs, setShowATMs] = useState(false);
    const [showBranches, setShowBranches] = useState(true);
    const [showIncidents, setShowIncidents] = useState(false);
    const [showServices, setShowServices] = useState(true);
    const [showRegionHierarchy, setShowRegionHierarchy] = useState(true);
    const [activeTab, setActiveTab] = useState("Region");
    const [kilometerRange, setKilometerRange] = useState(40);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [showDistricts, setShowDistricts] = useState(false);
    const [DistrictList, setDistrictList] = useState([]);
    const [panchayatNamenew, setpanchayatNamenew] = useState({});
    // const [selectedPanchayatIds, setSelectedPanchayatIds] = useState([]);
    // const [selectedVillageIds, setSelectedVillageIds] = useState([]);
    const [panchayatLayers, setPanchayatLayers] = useState({});
    const [villageLayers, setVillageLayers] = useState({});
    const [districtCoordinates, setDistrictCoordinates] = useState({});

    const [loader, setLoader] = useState(false);
    const [mapData, setMapData] = useState({
        branches: [],
        atms: [],
        incidents: [],
    });
    const [selectedLayers, setSelectedLayers] = useState({
        regionLayer: true,
        state: false,
        block: true,
    });
    const [loadingStates, setLoadingStates] = useState({
        districts: false,
        blocks: false,
        mapData: false
    });

    const [drawnShapes, setDrawnShapes] = useState([]);
    const [districtLayers, setDistrictLayers] = useState({});
    const [blockLayers, setBlockLayers] = useState({});
    const [filteredEntities, setFilteredEntities] = useState({
        branches: null,

        atms: null,

        incidents: null,
    });

    const [stateGeoJSON, setStateGeoJSON] = useState(null);

    const [districtGeoJSON, setDistrictGeoJSON] = useState({});

    const [activeDistricts, setActiveDistricts] = useState({});
    // const [showDistricts, setShowDistricts] = useState(false); // Controls visibility
    const [selectAllDistricts, setSelectAllDistricts] = useState(false); // Controls selection

    // Create a list of unique districts from branches
    const [districts, setDistricts] = useState([]);
    const [Coordinates, setCoordinates] = useState([]);
    const [allDistrictsSelected, setAllDistrictsSelected] = useState(false);
    const drawRef = useRef();
    const mapRef = useRef(null);
    const SearchControl = () => {
        const map = useMap();

        useEffect(() => {
            const provider = new OpenStreetMapProvider();
            const searchControl = new GeoSearchControl({
                provider,
                style: 'bar',
                showMarker: true,
                searchLabel: 'Search location...',
            });

            map.addControl(searchControl);

            // Dynamically inject CSS to style the dropdown
            const style = document.createElement('style');
            style.innerHTML = `
          /* Force black text in search results */
          .leaflet-control-geosearch .results * {
            color: black !important;
          }
          /* Background for dropdown items */
          .leaflet-control-geosearch .results > * {
            background: white !important;
            border-bottom: 1px solid #eee !important;
          }
          /* Hover effect */
          .leaflet-control-geosearch .results > *:hover {
            background: #f5f5f5 !important;
          }
        `;
            document.head.appendChild(style);

            return () => {
                map.removeControl(searchControl);
                document.head.removeChild(style); // Clean up
            };
        }, [map]);

        return null;
    };

    useEffect(() => {
        // Assuming DistrictList contains all possible districts
        setAllDistrictsSelected(selectedDistrictIds.length === DistrictList.length);
    }, [selectedDistrictIds, DistrictList]);
    useEffect(() => {
        if (selectedDistrictIds.length > 0 && mapRef.current) {
            const map = mapRef.current;

            // If all districts are selected (Bihar is selected)
            if (selectedDistrictIds.length === DistrictList.length) {
                if (stateGeoJSON) {
                    const tempLayer = L.geoJSON(stateGeoJSON);
                    const bounds = tempLayer.getBounds();
                    map.flyToBounds(bounds, {
                        padding: [50, 50],
                        duration: 1,
                        maxZoom: 8
                    });
                }
            }
            // If specific districts are selected
            else {
                const bounds = new L.LatLngBounds();
                let hasValidBounds = false;

                selectedDistrictIds.forEach(districtId => {
                    const districtLayer = districtLayers[districtId];
                    if (districtLayer) {
                        const tempLayer = L.geoJSON(districtLayer);
                        bounds.extend(tempLayer.getBounds());
                        hasValidBounds = true;
                    }
                });

                if (hasValidBounds) {
                    map.flyToBounds(bounds, {
                        padding: [50, 50],
                        duration: 1,
                        maxZoom: selectedDistrictIds.length === 1 ? 10 : 9
                    });
                } else if (stateGeoJSON) {
                    // Fallback to state bounds if no valid district bounds
                    const tempLayer = L.geoJSON(stateGeoJSON);
                    map.flyToBounds(tempLayer.getBounds(), {
                        padding: [50, 50],
                        duration: 1,
                        maxZoom: 8
                    });
                }
            }
        }
    }, [selectedDistrictIds, districtLayers, stateGeoJSON, DistrictList.length]);

    useEffect(() => {
        if (selectedBlockIds.length > 0 && mapRef.current && Object.keys(blockLayers).length > 0) {
            const map = mapRef.current;
            const bounds = new L.LatLngBounds();
            let hasValidBounds = false;

            selectedBlockIds.forEach(blockId => {
                const blockLayer = blockLayers[blockId];
                if (blockLayer) {
                    const tempLayer = L.geoJSON(blockLayer);
                    bounds.extend(tempLayer.getBounds());
                    hasValidBounds = true;
                }
            });

            if (hasValidBounds) {
                map.flyToBounds(bounds, {
                    padding: [50, 50],
                    duration: 1,
                    maxZoom: 14
                });
            }
        }
    }, [selectedBlockIds, blockLayers]);

    useEffect(() => {
        if (selectedPanchayatIds.length > 0 && mapRef.current && Object.keys(panchayatLayers).length > 0) {
            const map = mapRef.current;
            const bounds = new L.LatLngBounds();
            let hasValidBounds = false;

            selectedPanchayatIds.forEach(panchayatId => {
                const panchayatLayer = panchayatLayers[panchayatId];
                if (panchayatLayer) {
                    const tempLayer = L.geoJSON(panchayatLayer);
                    bounds.extend(tempLayer.getBounds());
                    hasValidBounds = true;
                }
            });

            if (hasValidBounds) {
                map.flyToBounds(bounds, {
                    padding: [50, 50],
                    duration: 1,
                    maxZoom: 16
                });
            }
        }
    }, [selectedPanchayatIds, panchayatLayers]);
    useEffect(() => {
        const fetchLayers = async () => {
            if (isLoading) {
                setLoader(true);
                return;
            }

            try {
                setLoader(true);

                // Fetch district layers
                const districtPromises = selectedDistrictIds.map(async (gisId) => {
                    try {
                        const response = await getData(gisCoordinatesData + gisId);
                        return response && response.length > 0
                            ? { gisId, geoJson: JSON.parse(response[0].coordinates) }
                            : null;
                    } catch (error) {
                        console.error(`Error fetching district ${gisId}:`, error);
                        return null;
                    }
                });

                // Fetch block layers
                const blockPromises = selectedBlockIds.map(async (gisId) => {
                    try {
                        const response = await getData(gisBlockCoordinatesData + gisId);
                        return response && response.length > 0
                            ? { gisId, geoJson: JSON.parse(response[0].coordinates) }
                            : null;
                    } catch (error) {
                        console.error(`Error fetching block ${gisId}:`, error);
                        return null;
                    }
                });

                // Fetch panchayat layers
                const panchayatPromises = selectedPanchayatIds.map(async (gisId) => {
                    try {
                        const response = await getData(gisPanchayatCoordinatesData + gisId);
                        if (response && response.length > 0) {
                            return {
                                gisId,
                                geoJson: JSON.parse(response[0].coordinates),
                                name: response[0].gpname // Store the name from the response
                            };
                        }
                        return null;
                    } catch (error) {
                        console.error(`Error fetching panchayat ${gisId}:`, error);
                        return null;
                    }
                });

                // Fetch village layers
                const villagePromises = selectedVillageIds.map(async (gisId) => {
                    try {
                        const response = await getData(gisVillageCoordinatesData + gisId);
                        return response && response.length > 0
                            ? { gisId, geoJson: JSON.parse(response[0].coordinates) }
                            : null;
                    } catch (error) {
                        console.error(`Error fetching village ${gisId}:`, error);
                        return null;
                    }
                });

                const [districtResults, blockResults, panchayatResults, villageResults] = await Promise.all([
                    Promise.all(districtPromises),
                    Promise.all(blockPromises),
                    Promise.all(panchayatPromises),
                    Promise.all(villagePromises)
                ]);

                // Process results
                const newDistrictLayers = {};
                districtResults.forEach(result => {
                    if (result) newDistrictLayers[result.gisId] = result.geoJson;
                });

                const newBlockLayers = {};
                blockResults.forEach(result => {
                    if (result) newBlockLayers[result.gisId] = result.geoJson;
                });

                const newPanchayatLayers = {};
                const panchayatNames = {}; // New object to store names

                panchayatResults.forEach(result => {
                    if (result) {
                        newPanchayatLayers[result.gisId] = result.geoJson;
                        panchayatNames[result.gisId] = result.name; // Store the name
                    }
                });

                setPanchayatLayers(newPanchayatLayers);
                setpanchayatNamenew(panchayatNames);

                const newVillageLayers = {};
                villageResults.forEach(result => {
                    if (result) newVillageLayers[result.gisId] = result.geoJson;
                });

                setDistrictLayers(newDistrictLayers);
                setBlockLayers(newBlockLayers);
                // setPanchayatLayers(newPanchayatLayers);
                setVillageLayers(newVillageLayers);
            } catch (error) {
                console.error("Error fetching layers:", error);
            } finally {
                setLoader(false);
            }
        };

        if (selectedDistrictIds || selectedBlockIds ||
            selectedPanchayatIds || selectedVillageIds) {
            fetchLayers();
        } else {
            setDistrictLayers({});
            setBlockLayers({});
            setPanchayatLayers({});
            setVillageLayers({});
            setLoader(false);
        }
    }, [selectedDistrictIds, selectedBlockIds, selectedPanchayatIds, selectedVillageIds, isLoading]);

    useEffect(() => {
        if (selectedVillageIds.length > 0 && mapRef.current && Object.keys(villageLayers).length > 0) {
            const map = mapRef.current;
            const bounds = new L.LatLngBounds();
            let hasValidBounds = false;

            selectedVillageIds.forEach(villageId => {
                const villageLayer = villageLayers[villageId];
                if (villageLayer) {
                    const tempLayer = L.geoJSON(villageLayer);
                    bounds.extend(tempLayer.getBounds());
                    hasValidBounds = true;
                }
            });

            if (hasValidBounds) {
                map.flyToBounds(bounds, {
                    padding: [50, 50],
                    duration: 1,
                    maxZoom: 18
                });
            }
        }
    }, [selectedVillageIds, villageLayers]);



    const toggleFullscreen = () => {
        if (isFullscreen) {
            handle.exit();
        } else {
            handle.enter();
        }
        setIsFullscreen(!isFullscreen);
    };

    const mapStateCoordinates = async () => {
        try {
            const res = await getData(gisStateCoordinates + 52); // Assuming 52 is Bihar's state_id

            if (res && res.length > 0) {
                const stateData = res[0];
                // Parse the coordinates string into a GeoJSON object
                const geoJsonData = {
                    type: "Feature",
                    properties: {
                        name: stateData.state_name,
                        state_id: stateData.state_id,
                    },
                    geometry: JSON.parse(stateData.coordinates),
                };
                setStateGeoJSON(geoJsonData);
            }
        } catch (error) {
            console.error("Error fetching state coordinates:", error);
            toast.error("Failed to load state coordinates");
        }
    };




    const facilityIcons = {
        hospital: new L.Icon({
            iconUrl: 'https://cdn-icons-png.flaticon.com/512/580/580902.png',
            iconSize: [25, 25]
        }),
        school: new L.Icon({
            iconUrl: 'https://cdn-icons-png.flaticon.com/512/563/563031.png',
            iconSize: [25, 25]
        }),
        default: new L.Icon({
            iconUrl: 'https://cdn0.iconfinder.com/data/icons/small-n-flat/24/678111-map-marker-512.png',
            iconSize: [25, 41]
        })
    };
    const getFacilityIcon = (type) => {
        return facilityIcons[type] || facilityIcons.default;
    };

    // Find center point for the map based on available branch locations
    const getMapCenter = () => {
        if (mapData.branches && mapData.branches.length > 0) {
            return mapData.branches[0].position;
        }
        // Default center if no branches
        return [25.5941, 85.1376];
    };
    const LocationMarker = ({ onLocationSelect }) => {
        useMapEvents({
          click(e) {
            console.log('Map clicked at:', e.latlng);
            const { lat, lng } = e.latlng;
    
            // Store the clicked point
            setClickedPoint({
              lat,
              lng,
              timestamp: Date.now() // Add timestamp to force re-render if clicking same spot
            });
            onLocationSelect({
              latitude: e.latlng.lat,
              longitude: e.latlng.lng
            });
          }
        });
        return clickedPoint ? (
          <Marker
            position={[clickedPoint.lat, clickedPoint.lng]}
            icon={redDotIcon}
            interactive={true}
          >
            {/* <Popup>
            <div>
              <strong>Coordinates:</strong><br />
              Latitude: {clickedPoint.lat.toFixed(6)}<br />
              Longitude: {clickedPoint.lng.toFixed(6)}
            </div>
          </Popup> */}
          </Marker>
        ) : null;
      };

    return (

        <FullScreen handle={handle}>
            <div style={{
                display: "flex",
                height: "60vh",
                fontFamily: "Arial, sans-serif",
                position: "sticky" // Add this
            }}>
                {loader && (
                    <Loader
                        show={loader}
                        type="body"
                        stack="vertical"
                        message="Loading Data"
                    />
                )}



                {/* Map Section */}
                <div style={{ flex: 1 }}>
                    <MapContainer
                        ref={mapRef}
                        center={getMapCenter()}
                        attributionControl={false}
                        zoom={7}
                        style={{
                            width: "100%",
                            height: "100%",
                        }}
                        // onClick={handleMapClick}
                        whenCreated={(mapInstance) => {
                            mapRef.current = mapInstance;
                        }}
                    >
                        <SearchControl />
                        <LayersControl position="topright" collapsed={false}>
                            <LayersControl.BaseLayer name="Road View">
                                <TileLayer
                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />
                            </LayersControl.BaseLayer>

                            <LayersControl.BaseLayer name="Satellite View">
                                <TileLayer
                                    attribution=""
                                    url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                                    maxZoom={20}
                                    subdomains={["mt0", "mt1", "mt2", "mt3"]}
                                />
                            </LayersControl.BaseLayer>

                            <LayersControl.BaseLayer checked name="Terrain View">
                                <TileLayer
                                    attribution=""
                                    url="https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}"
                                    maxZoom={20}
                                    subdomains={["mt0", "mt1", "mt2", "mt3"]}
                                />
                            </LayersControl.BaseLayer>

                            <LayersControl.BaseLayer name="Hybrid View">
                                <TileLayer
                                    attribution=""
                                    url="https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"
                                    maxZoom={20}
                                    subdomains={["mt0", "mt1", "mt2", "mt3"]}
                                />
                            </LayersControl.BaseLayer>
                        </LayersControl>

                        <LocationMarker onLocationSelect={onLocationSelect} />

                        {Object.entries(panchayatLayers).map(([gisId, geoJson]) => {
                            const regionData = selectedRegions.find(region => region.gis_id === parseInt(gisId));
                            const isRecentlySelected = selectedPanchayatIds[selectedPanchayatIds.length - 1] === gisId;
                            const panchayatName = panchayatNamenew[gisId] || `Panchayat ${gisId}`; // Get the stored name

                            return (
                                <GeoJSON
                                    key={`panchayat-${gisId}`}
                                    data={geoJson}
                                    style={{
                                        color: isRecentlySelected ? "#00aa00" : "#00aa00",
                                        weight: isRecentlySelected ? 2 : 1,
                                        opacity: 1,
                                        fillColor: "#00aa00",
                                        fillOpacity: 0.3,
                                        maxZoom: 16
                                    }}
                                    eventHandlers={{
                                        click: (e) => {
                                            e.originalEvent.preventDefault();
                                            e.originalEvent.stopPropagation();
                                            const bounds = e.target.getBounds();
                                            mapRef.current.flyToBounds(bounds, {
                                                padding: [50, 50],
                                                duration: 1,
                                                maxZoom: 16
                                            });
                                        },
                                        mouseover: (e) => {
                                            const layer = e.target;
                                            layer.setStyle({
                                                weight: 2,
                                                color: "#ff0000"
                                            });
                                        },
                                        mouseout: (e) => {
                                            const layer = e.target;
                                            const isSelected = selectedPanchayatIds.includes(gisId);
                                            layer.setStyle({
                                                weight: isSelected ? 2 : 1,
                                                color: isSelected ? "#ff0000" : "#00aa00"
                                            });
                                        }
                                    }}
                                    onEachFeature={(feature, layer) => {
                                        const displayName = regionData?.name || panchayatName ||
                                            (feature.properties && feature.properties.name) ||
                                            `Panchayat ${gisId}`;

                                        layer.bindTooltip(`<b>${displayName}</b>`, {
                                            permanent: false,
                                            direction: 'top',
                                            className: 'map-tooltip'
                                        });

                                        if (feature.properties && feature.properties.name) {
                                            layer.bindPopup(`<b>${feature.properties.name}</b>`);
                                        }
                                    }}
                                />
                            );
                        })}


                    </MapContainer>
                </div>


            </div>
        </FullScreen>



    );
};


export default EventMap;